import ApproveRegistrationDialogContainer from "./approveRegistrationDialog.container";

export default ApproveRegistrationDialogContainer;
